angular.module('main').directive('snSelect', [
	function() {
		return {
			restrict: 'AE',
			scope: {
				defaultText: '=',
				allItems: '=',
				labelField: '@'
			},
			template() {
				let html = '';
				html += '<div class="select-style"><span>Inner thing</span>';
				html += 'ХХshowLabel{{showLabel}}';

				// html += "    <div class=\"head\" ng-click=\"active=!active\">";
				// html += "        <span ng-hide=\"showLabel\">{{defaultText}}<\/span>";
				// html += "        <div ng-show=\"showLabel\">";
				// //html += "            <i class=\"jt-{{jobTypeEdit.colour | lowercase}}\"><\/i>";
				// html += "            <span>{{jobTypeEdit.colour}}<\/span>";
				// html += "        <\/div>";
				// html += "    <\/div>";
				//
				// html += "    <ul class=\"options\">";
				// html += "        <li ng-repeat=\"item in items\" class=\"form-control\" ng-click=\"setColor(colour, $event);\">";
				// html += "            <i class=\"jt-{{colour | lowercase}}\"><\/i>";
				// html += "            <span>{{colour}}<\/span>";
				// html += "        <\/li>";
				// html += "    <\/ul>";

				html += '</div>';

				return html;
			},
			replace: true,
			link(scope, element) {
				// console.log('scope');
				// console.dir(scope);
				//
				// element.data('thing', true);
				//
				// scope.itemsOrigin = angular.copy(scope.items);
				// //scope.defaultText = angular.copy(scope.defaultText);
				//
				// angular.element($document[0].body).on('click', function (e) {
				//    //var inThing = angular.element(e.target).inheritedData('thing');
				//    //if (inThing) {
				//        $window.alert('in');
				//    //} else {
				//    //    $window.alert('out');
				//    //}
				// })
			}
		};
	}
]);



// WEBPACK FOOTER //
// ./web/js/components/Elements/snSelect.js